import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { mediaImages, MediaDocImagesResponse, MediaImagesResponse, ROIRefreshFlagResponse } from '../models/mediaImages.model';
import { mediaDoc } from '../models/mediaImages.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';
import { PaymentDocMediaImagesResponse } from '../models/PaymentDocImage.model';


@Injectable()
export class MediaImagesService {
    private baseUrl: string; // = "https://localhost:44353/api/officesetup";
    private api: string = "api/MediaImages";


    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    private handleErrors(errorResponse: HttpErrorResponse) {
        if (errorResponse.error instanceof ErrorEvent) {
            console.error('MediaImages Service Client Side Error: ', errorResponse.error.message);
        } else {
            console.error('MediaImages Service Server Side Error: ', errorResponse);
        }

        return throwError("There is a problem with the service. We are notified & working on it. Please try again later.");
    }

    getROIRefreshFlag(inventionId: number, isRefreshCall: number, encryptedUser: string): Observable<ROIRefreshFlagResponse> {
        return this.httpClient

            .get<ROIRefreshFlagResponse>(`${this.baseUrl}/GetROIRefreshFlag/${inventionId}/${isRefreshCall}`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser,
                    'Retry-After': '15'
                })
            }).pipe(delayedRetryHttp(10000), catchError(err => { return this._utilityService.handleErrors(err, null, "inventionId - " + inventionId, "MediaImagesService", "getROIRefreshFlag"); }));

    }

    getMediaImageList(inventionId: number, lastAdded: number, encryptedUser: string): Observable<MediaImagesResponse> {
        return this.httpClient

            .get<MediaImagesResponse>(`${this.baseUrl}/${inventionId}/${lastAdded}`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp(10000), catchError(err => { return this._utilityService.handleErrors(err, null, "inventionId - " + inventionId, "MediaImagesService", "getMediaImageList"); }));

    }

    getMediaDocList(inventionId: number, lastAdded: number, encryptedUser: string): Observable<MediaDocImagesResponse> {
        return this.httpClient
            .get<MediaDocImagesResponse>(`${this.baseUrl}/GetMediaDoc/${inventionId}/${lastAdded}`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp(10000), catchError(err => { return this._utilityService.handleErrors(err, null, "inventionId - " + inventionId, "MediaImagesService", "getMediaDocList"); }));
    }

    DeleteDocumentMediaByID(mediaID: number, inventionID: number, encryptedUser: string): Observable<MediaDocImagesResponse> {
        return this.httpClient
            .get<MediaDocImagesResponse>(`${this.baseUrl}/DeleteDocumentMediaByID/${mediaID}/${inventionID}`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp(10000), catchError(err => { return this._utilityService.handleErrors(err, null, "mediaID - " + mediaID + " inventionId - " + inventionID, "MediaImagesService", "DeleteDocumentMediaByID"); }));
    }

    DeleteInventionMediaByID(mediaID: number, inventionID: number, encryptedUser: string): Observable<MediaImagesResponse> {
        return this.httpClient
            .get<MediaImagesResponse>(`${this.baseUrl}/DeleteInventionMediaByID/${mediaID}/${inventionID}`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp(10000), catchError(err => { return this._utilityService.handleErrors(err, null, "mediaID - " + mediaID + " inventionId - " + inventionID, "MediaImagesService", "DeleteInventionMediaByID"); }));
    }

    getPaymentDocList(encryptedUser: string, contractSessionId: number, contractMultiPaymentId: number, payType: number): Observable<PaymentDocMediaImagesResponse> {
        return this.httpClient
            .get<PaymentDocMediaImagesResponse>(`${this.baseUrl}/GetPaymentDoc/${contractSessionId}/${contractMultiPaymentId}/${payType}`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp(10000), catchError(err => { return this._utilityService.handleErrors(err, null, "contractSessionId - " + contractSessionId, "MediaImagesService", "getPaymentDocList"); }));

    }

    getInventorImageList(inventionId: number, lastAdded: number, encryptedUser: string): Observable<MediaImagesResponse> {
        return this.httpClient
            .get<MediaImagesResponse>(`${this.baseUrl}/InventionMedia_GetInventorImage/${inventionId}/${lastAdded}`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp(10000), catchError(err => { return this._utilityService.handleErrors(err, null, "inventionId - " + inventionId, "MediaImagesService", "getInventorImageList"); }));
    }

    getCurruptedMediaImageList(inventionId: number, encryptedUser: string): Observable<MediaImagesResponse> {
        return this.httpClient

            .get<MediaImagesResponse>(`${this.baseUrl}/GetCurruptedImage/${inventionId}`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp(10000), catchError(err => { return this._utilityService.handleErrors(err, null, "inventionId - " + inventionId, "MediaImagesService", "getMediaImageList"); }));

    }
}
